export default "__VITE_ASSET__DFyc5QAZ__"